import { AauthService } from 'src/app/services/aauth.service';
import { AlertService, MessageSeverity } from '@app/services/alert.service';
import { ClaimResultModel, ClaimFinalizationModel } from '@app/models/claims.model';
import { ClaimService } from '@app/feature-modules/claim/claim.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ConfigurationService } from 'src/app/services/configuration.service';
// import { DBkeys } from '@app/services/db-keys';
import { LocalStoreManager } from 'src/app/services/local-store-manager.service';
import { Router, ActivatedRoute } from '@angular/router';
// import { SignupResultModel } from '@app/models/register.model';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-claim-finalize',
  templateUrl: './claim-finalize.component.html',
  styleUrls: ['./claim-finalize.component.scss']
})

export class ClaimFinalizeComponent implements OnInit {
  isLoading = true;
  bigtimeError = false;
  pId: number;
  token: string;
  verifyResultModel = new ClaimResultModel(true, '');
  validpassword = true;
  passwordsmatch = true;

  constructor(private alertService: AlertService,
    private router: Router,
    public authService: AauthService,
    private configurations: ConfigurationService,
    private localStorage: LocalStoreManager,
    public claimService: ClaimService,
    private route: ActivatedRoute) {

    this.route.queryParams.subscribe(async params => {
      const flyout = params['fly'];
      if (flyout === '1') {
        this.claimService._isFlyout = true;
      }

      try {
        this.pId = params['pId'];
      }
      catch { }

      try {
        this.token = params['token'];
      }
      catch { }

      if (this.pId !== undefined && this.pId !== null) {
        this.verifyToken(this.pId, this.token);
      }
      else {
        this.bigtimeError = true;
      }
    });
  }

  ngOnInit(): void {}

  verifyToken(id: number, token: string) {
    this.isLoading = true;
    return this.authService.verifyClaimToken(id, token).subscribe(res => {
      this.verifyResultModel = res;
      if (!this.verifyResultModel.success) {
        this.alertService.showMessage("Verification Issue", "We're sorry - your token is either expired or invalid.", MessageSeverity.error);
      }
      this.isLoading = false;
    }),
      catchError(err => {
        console.log(err);
        this.isLoading = false;
        this.verifyResultModel = new ClaimResultModel(false, err);
        this.alertService.showMessage("Verification Issue", `We're sorry - there was an error validation your token. ${err}`, MessageSeverity.error);
        return of<any>([]);
      });
  }

  completeClaim() {
    this.isLoading = true;
    const model = new ClaimFinalizationModel(this.pId, this.authService.finalizeClaimModel.value.passwords.password, this.authService.finalizeClaimModel.value.racaptcha);
    return this.authService.finalizeClaim(model).subscribe(res => {
      const retModel = res;
      if (retModel.success) {
        this.alertService.showMessage("Completed", "Claim process succeeded! Forwarding to your profile.", MessageSeverity.success);
        this.authService.locationTo('/Professional/Edit');
      }
      else {
        this.isLoading = false;
        this.alertService.showMessage("Finalize Issue", "We're sorry - there was an issue finalizing your claim.", MessageSeverity.error);
      }
    }),
      catchError(err => {
        console.log(err);
        this.isLoading = false;
        this.verifyResultModel = new ClaimResultModel(false, err);
        this.alertService.showMessage("Finalize Issue", `We're sorry - there was an issue finalizing your claim. ${err}`, MessageSeverity.error);
        return of<any>([]);
      });
  }

  passwordValid() {
    const formModel = this.authService.finalizeClaimModel;
    const ucase = new RegExp("[A-Z]+");
    const num = new RegExp("[0-9]+");
    const password = formModel.value.passwords.password;
    const isBlank = password === '';
    if (isBlank) {
      return true;
    }
    const invalidLen = isBlank || (password.length < 6);
    const invalidChars = !(ucase.test(password) && num.test(password) && !(/^[a-zA-Z0-9- ]*-_+$/.test(password)));
    this.validpassword = !isBlank && !invalidLen && !invalidChars;
    return this.validpassword;
  }

  confirmPasswordValid() {
    let pwdMatch = false;
    const formModel = this.authService.finalizeClaimModel;
    const password = formModel.value.passwords.password;
    const cfmPassword = formModel.value.passwords.confirmPassword;
    if (password === cfmPassword) {
      pwdMatch = true;
    }
    this.passwordsmatch = pwdMatch;
    return this.passwordsmatch;
  }

  async reCaptchaResolved(captchaResponse: string) {
    await this.sendCaptchaToBackend(captchaResponse);
  }

  sendCaptchaToBackend(captcha: any) {
  this.authService.sendCaptchaToBackend(captcha).subscribe(
      (data: any) => {
      },
      error => {
        const ctrl =  this.authService.finalizeClaimModel.get('recaptcha');
        ctrl.reset();
        this.alertService.showError(error);
      }
    );
  }

  formIsValid() {
    const passwordsValid = (this.passwordValid() && this.confirmPasswordValid());
    const recaptchaValid = this.authService.isLocalHost() ? true: this.authService.finalizeClaimModel.value.recaptcha;
    const agreedValid = this.authService.finalizeClaimModel.value.agree;
    const isValid = (passwordsValid && recaptchaValid && agreedValid);
    return isValid;
  }
}
